module.exports = __webpack_public_path__ + "37d7c697eda12c8a04f91501cf33b224.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-panel-1050.webp.png
// module id = 337
// module chunks = 0